import {
  useCallback,
} from 'react';
import {
  useConfirmDialog,
  useNotify,
} from 'core/hooks';
import {
  useDeletePatientAuthorization,
} from 'views/EMR/components/Authorizations/hooks';

type Props = {
  onDeleted?: () => void | Promise<void>;
};

export default function useAuthorizationDelete({ onDeleted }: Props) {
  const {
    confirm,
    closeConfirm,
  } = useConfirmDialog();
  const notify = useNotify();
  const {
    mutateAsync: deleteAuthorization,
    isPending,
  } = useDeletePatientAuthorization();

  const requestDelete = useCallback((
    authorizationId: number,
    authorizationNumber: string,
  ) => {
    if (authorizationId <= 0) {
      return;
    }

    confirm({
      title: 'Delete Authorization',
      content: `Are you sure you want to delete ${authorizationNumber}?`,
      confirmText: 'Confirm',
      onConfirm: async () => {
        try {
          await deleteAuthorization(authorizationId);
          closeConfirm();
          await onDeleted?.();
          notify({
            variant: 'success',
            message: 'Authorization deleted successfully',
          });
        } catch (error) {
          console.error('Error deleting authorization:', error);
        }
      },
    });
  }, [closeConfirm, confirm, deleteAuthorization, notify, onDeleted]);

  return {
    requestDelete,
    isPending,
  };
}
